export interface ApiResponseType<T> {
  data?: T;
  message: string;
}

export interface ApiErrorType {
  error: string;
}

export enum NetworkType {
  BEP_20 = 1,
  TRC_20,
  ULTRON,
  BASE_CHAIN
}

export enum WalletNFTType {
  FLIPME = 1,
  METAMASK
}

export enum AkashaCoinsType {
  ULTRON,
  AKAHSA
}

export interface WalletsType {
  networkType: NetworkType;
  icon: any;
  wallet: string;
  index: number;
}

export interface WalletsNFTType {
  type: WalletNFTType;
  icon: any;
  wallet: string;
  index: number;
}

export interface TokensType {
  icon: any;
  token: string;
  index: number;
  value?: string;
  name?: string;
}

export interface RefreshTokenResponse {
  refreshToken: NetworkType;
}

export enum CurrencyType {
  BANK_TRANSFER = 1,
  SHOPPING_POINTS,
  REWARD_POINTS,
  LOYALTY_POINTS,
  MIX,
  USDC = 7
}
